import Link from 'next/link';
import React from 'react';
import * as rdd from 'react-device-detect';
import { func, links } from '../helpers';
import Vote from './Vote';


const Card = (props) => {

    const { kay, row, org, ctg, award, stages, bulkPrices } = props;

    const [vote, setVote] = React.useState(false);
    const [isMobile, setIsMobile] = React.useState(true);

    React.useEffect(() => {
        setIsMobile(rdd.isMobile);
    }, []);

    const config = {
        ticket: {
            image: row.logo_link,
        },
        award: {
            image: row.logo_link,
        },
        nominee: {
            image: row.avatar ? row.avatar_link : row.award?.logo_link,
        },
        category: {
            image: row.award?.logo ? row.award?.logo_link : org.logo_link,
        }
    };

    const lowTicket = (tickets) => {
        let prices = tickets.map(t => { return +t.price });
        var min = Math.min.apply(Math, prices);
        return tickets.find(t => +t.price === min) || { price: 0 };
    }

    const stage = (stages || []).find(stage => func.checkDates(stage.date.start, stage.date.end)) || { name: '', date: { start: '2020', end: '2020' } };
    const date = (stages || []).length > 0 ? stage.date : award?.date_voting;

    return (
        <React.Fragment>
            {isMobile ? (
                <article key={row.uuid} className="col-lg-12 hover-ups-2 transition-normal wows fadeInUp animated">
                    <div className="post-card-1 mobile p-10 mb-20">
                        <div className="row list-style-2s d-flex align-items-center">
                            <div className="col-3">
                                <div className="post-thumb position-relative border-radius-5">
                                    <div className="img-hover-slide border-radius-5 position-relative"
                                        style={{ backgroundImage: `url(${config[kay].image})`, minHeight: 65 }}>
                                        <Link href={links[kay](row, ctg).href} as={links[kay](row, ctg).as}>
                                            <a className="img-link"></a>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            <div className="col-9 align-self-center" style={{ paddingLeft: 0 }}>
                                <div className="post-content">
                                    <div className="entry-meta meta-0 font-small mb-8s">
                                        <a><span className="post-cat text-secondary">{kay === 'nominee' ? ctg.name : org.name}</span></a>
                                    </div>
                                    <h6 className="post-title font-weight-900s mb-0 text-truncate" style={{ fontWeight: 700 }}>
                                        <Link href={links[kay](row, ctg).href} as={links[kay](row, ctg).as}>
                                            <a>{row.name}</a>
                                        </Link>
                                    </h6>
                                    {kay === 'event' && (
                                        <>
                                            <div className="text-muted text-truncate small mt-5">
                                                {row.location}
                                            </div>
                                            <div className="primary text-truncate small mt-5 font-weight-500">
                                                {row.tickets.length > 1 ? 'Starts at ' : ''} {row.country.currency} {func.numberFormat(lowTicket(row.tickets).price, 2)}
                                            </div>
                                        </>
                                    )}
                                    {kay === 'nominee' && func.checkDates(date.start, date.end) && (
                                        <div className="btn btn-sms btn-blocks btn-primary btn-round font-weight-500 mt-20 py-0" onClick={() => setVote(true)}>
                                            <small>&nbsp; &nbsp; &nbsp; &nbsp; {func.intl('Button.Vote', 'Vote')} &nbsp; &nbsp; &nbsp; &nbsp;</small>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </article>
            ) : (
                <article key={row.uuid} className="col-lg-3 col-md-6 mb-30 wows fadeInUp animated">
                    <div className="post-card-1 border-radius-10 hover-ups">
                        <div className="post-thumb thumb-overlay img-hover-slide position-relative"
                            style={{ backgroundImage: `url(${config[kay].image})`, minHeight: 200 }}>
                            <Link href={links[kay](row, ctg).href} as={links[kay](row, ctg).as}>
                                <a className="img-link"></a>
                            </Link>
                        </div>
                        <div className={`post-content p-15 ${kay !== 'event' ? 'text-center' : ''}`}>
                            <div className="entry-meta meta-0 font-small mb-5 text-truncate">
                                <a style={{ cursor: 'auto' }}>
                                    <span className="post-cat text-secondary">{kay === 'nominee' ? ctg.name : org.name}</span>
                                </a>
                            </div>
                            <div className="d-flex post-card-content">
                                <h6 className="post-title mb-0 font-weight-900 text-truncate">
                                    <Link href={links[kay](row, ctg).href} as={links[kay](row, ctg).as}>
                                        <a>{row.name}</a>
                                    </Link>
                                </h6>
                                {kay === 'event' && (
                                    <>
                                        <div className="text-muted text-truncate small mt-5">
                                            {row.location}
                                        </div>
                                        <div className="primary text-truncate small mt-5 font-weight-500">
                                            {row.tickets.length > 1 ? 'Starts at ' : ''} {row.country.currency} {func.numberFormat(lowTicket(row.tickets).price, 2)}
                                        </div>
                                    </>
                                )}
                                {kay === 'nominee' && func.checkDates(date.start, date.end) && (
                                    <div className="row mt-20">
                                        <div className="col-3"></div>
                                        <div className="col-6">
                                            <div className="btn btn-sm btn-block btn-primary btn-round font-weight-500" onClick={() => setVote(true)}>
                                                <small>{func.intl('Button.Vote', 'Vote')}</small>
                                            </div>
                                        </div>
                                        <div className="col-3"></div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </article>
            )}

            {kay === 'nominee' && (
                <Vote
                    {...props}
                    ctg={ctg} award={award}
                    visible={vote}
                    nominee={row}
                    country={org.country}
                    isForeign={props.isForeign}
                    bulkPrices={bulkPrices}
                    onCancel={() => {
                        setVote(false);
                    }}
                    onSuccess={() => {

                    }}
                />
            )}
        </React.Fragment>
    );
}

export default Card;